module.exports = __webpack_public_path__ + "static/img/bannera.14a5f27.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bannera.jpg
// module id = hZSY
// module chunks = 1